import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import nop from "../Strict/nop.js";
export default function go2(acc, a, f) {
  return a instanceof _Promise ? a.then(function (a) {
    return f(acc, a);
  }, function (e) {
    return e == nop ? acc : _Promise.reject(e);
  }) : f(acc, a);
}